module.exports = __webpack_public_path__ + "img/settings.ae107f08.svg";